<template>
  <table-list
      ref="list"
      :height="height"
      @query="handleLoadList"
      :request-params="{userNum: $route.query.num, status}"
      :auto="false"
      :back-top="false"
      :pageSizes="[5, 10]"
      :data="tableData">
    <el-table-column align="center" :label="$t('编号')" prop="num" />
    <el-table-column align="center" :label="$t('图片')">
      <template v-slot="{row}">
        <div class="fb-link-flex">
          <el-image
              v-for="item in row.coverList"
              :key="item"
              fit="cover"
              :preview-src-list="item.photoList"
              :src="$api.file.downloadImg + item" />
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center" :label="$t('名称')" prop="name" />
    <el-table-column align="center" :label="$t('分类')" prop="sortName" />
    <el-table-column align="center" prop="property" :label="$t('菜谱属性')">
      <template v-slot="{row}">
        <dict-text :status="row.property" dict-flag="RECIPE_ATTRS" />
      </template>
    </el-table-column>

    <el-table-column align="center" :label="$t('能量值')" prop="calorie" />

    <!--  审核中显示  -->
    <el-table-column align="center" :label="$t('发布时间')" v-if="status === 'audit'">
      <template v-slot="{row}">
        {{ row.createTime | formatDate }}
      </template>
    </el-table-column>

    <el-table-column align="center" :label="$t('菜谱收入')" prop="cookbookPrice" />
    <el-table-column align="center" prop="collectCount" :label="$t('收藏次数')" />
    <el-table-column align="center" :label="$t('观看次数')" prop="watchCount" />
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import DictText from "@/components/dict/DictText";
export default {
  name: "UserRecipeList",
  components: {DictText, TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.cookbook.list, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        this.tableData = this.tableData.map(item => {
          item.coverList = item.cover ? item.cover.split(",") : [];
          return item;
        })
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
